/**
 * StreamRiftGate - Password gate for the StreamRift view.
 *
 * SessionStorage persistence (tab-scoped), on the shared gate contract.
 */

import { type GateNamespace } from '@/lib/infra/gateStorage';
import { PasswordGate } from '@/components/organisms/PasswordGate';

const STREAMRIFT_HASH = 'a9669b23c4091e2c098883504e59a288ac7557a5d3e52f52677670a0f13f5e1a';

/** Session-only, unbound — the shipped StreamRift behavior. */
export const STREAMRIFT_GATE: GateNamespace = { sessionKey: 'streamrift_unlocked' };

export function StreamRiftGate({ onUnlock }: { onUnlock: () => void }) {
  return (
    <PasswordGate
      title="StreamRift"
      subtitle="Enter password to continue"
      namespace={STREAMRIFT_GATE}
      expectedHash={STREAMRIFT_HASH}
      onUnlock={onUnlock}
    />
  );
}
